<template>
  <!-- CONTACTS SECTION -->
  <div class="help-section help-contacts">
    <div class="section-header">
      <div @click="back" class="icon icon--s icon-back mr-3"></div>
      Contattaci
    </div>
    <div class="section-intro">
      <p class="section-intro--title f-m">
        Hai bisogno di aiuto con Tinaba?
      </p>
      <p class="mb-3 text-grey">Ecco come fare:</p>
    </div>
    <div class="section-content">
      <div @click="openChat" class="cursor-pointer section-row f-m">
        Apri la chat
      </div>
      <a href="mailto:support@tinaba.it" class="section-row f-m">
        Inviaci una email
      </a>
      <div
        class="section-row section-row--twolines text-grey"
        style="align-items: center;"
      >
        oppure
      </div>
      <a
        :href="getWhatsappLink()"
        class="section-row section-row--twolines f-m"
      >
      
        <p>WhatsApp al +39 337 1425932</p>
        <p class="f-r text-grey">Salva il numero nella tua rubrica</p>
      </a>
      <a href="tel:800694950" class="section-row section-row--twolines f-m">
        <p>Chiamaci al <span>800.694.950</span></p>
        <p class="f-r text-grey">
          Numero verde raggiungibile <b>dall'Italia</b>
        </p>
      </a>
      <a href="tel:0298670060" class="section-row section-row--twolines f-m">
        <p>Chiamaci al <span>02.98.67.00.60</span></p>
        <p class="f-r text-grey">Per chiamare <b>dall'estero</b></p>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contacts",
  components: {},

  data() {
    return {};
  },
  mounted() {},
  methods: {
    getWhatsappLink() {
      /**
       * Use https://wa.me/<number> where the <number> is a full phone number in international format.
       * Omit any zeroes, brackets, or dashes when adding the phone number in international format.
       * Source: https://faq.whatsapp.com/general/chats/how-to-use-click-to-chat
       */
      const whatsappPhoneNumber = "393371425932"; //

      return `https://wa.me/${whatsappPhoneNumber}`;
    },
    openChat() {
      this.$root.$emit("closeHelp");
      window.openChorallyChat();
    },
    back() {
      console.log("back");
      this.$root.$emit("helpBack");
    }
  }
};
</script>
